import {EditorContentLazy} from 'app/modules/editorContent/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineEditorContent(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-editor-content')) {
        return;
    }

    customElements.define(
        'gem-editor-content',
        class extends WebComponentLoader {
            reactLazyComponent = EditorContentLazy;
            removePortalContent = false;
            hasConfig = false;
        },
    );
}
